const escapeSpecialChar = string => {
  const map = {
    '#': '%23',
    ';': '%3B',
    '?': '%3F'
  }

  return string.replace(/[#;?]/g, function(m) {return map[m]})
}

module.exports = escapeSpecialChar


// WEBPACK FOOTER //
// ./src/utils/escapeSpecialChar.js